import React from 'react';
import { Container } from 'react-bootstrap';

const PlayersWanted: React.FC = () => {
  return (
    <Container className="p-3 my-4">
      <h1>PLAYERS WANTED</h1>
      <p>Information about our club's teams will be available here soon.</p>
    </Container>
  );
};

export default PlayersWanted;